export const layoutsMisc = {
  confirm: {
    defaultTitle: "هل أنت متأكد؟",
    confirm: "تأكيد",
    cancel: "إلغاء",
  },
  navPluginWeb: {
    title: "إنشاء موقع إلكتروني",
    stepOf: "{step} من 5",
  },
  saMenu: {
    title: "إجراءات النظام",
    subtitle: "لوحة الأتمتة",
    sectionComms: "الاتصالات",
    firstCheckin: "الإرسال عند أول تسجيل وصول",
  },
  systemActions: {
    checkin: "تسجيل الوصول",
  },
  regionMessage: {
    text: "تواصل مع فريق الدعم لإتمام عملية الربط.",
    contactSupport: "التواصل مع الدعم",
  },
  selectionScanner: {
    title: "اختر نوع المستند المراد مسحه ضوئياً",
    idCard: "بطاقة الهوية",
    passport: "جواز السفر",
  },
};
